import React from 'react'
import Layout from '../Layout';

export default function Healthcare() {
  return (
    <Layout>
    <div className='content1'>Healthcare</div>
    </Layout>
  )
}
